export const environment = {
  production: false,
  base_url: 'https://api-dev.dubaiownersclub.com/api/v1/admin/',
  image_base_url: 'https://api-dev.dubaiownersclub.com/api/v1/upload/uploadFile',
  googleApiKey: '',
  storageKey: 'realEstateAccessToken',
  verificationTimerValue: 'verificationTimerValue',
  rememberMeKey: 'isRememberMeRealEstate'
};
